/* global attachEvent, axios, localData */

attachEvent('.news-list__archive', 'click', (ev) => {
  ev.preventDefault();

  const button = ev.target.closest('.news-list__archive');
  const newsList = button.closest('.news-list');
  const list = newsList.querySelector('.news-list__inner');

  if (!list || newsList.classList.contains('is-loading')) {
    return;
  }

  newsList.classList.add('is-loading');

  const nextView = button.dataset.view === 'past' ? 'future' : 'past';
  const formData = new FormData();
  formData.append('action', 'getPastEvents');
  formData.append('type', nextView);
  formData.append('lang', localData.lang);

  axios
    .post(localData.siteURL, formData)
    .then((response) => {
      list.innerHTML = response.data.data.html;
      button.dataset.view = nextView;
      const label = button.querySelector('.btn__text');
      if (label) {
        label.textContent = nextView === 'past' ? button.dataset.futureText : button.dataset.archiveText;
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      newsList.classList.remove('is-loading');
    });
});
